import { VariantResource, Variants } from "./resource";

export const COMMON: VariantResource<Variants> = {
  DOCUMENT_TITLE: "Returns & Exchanges",
  TYPE_DISPLAY_NAME: "return",
  ORDERLESS_DISPLAY_NAME: "Third-party",
  LOGIN_FIELD_ONE_LABEL: "Email or Zip/Postal",
  LOGIN_FIELD_TWO_LABEL: "Order # or Tracking #",
  PORTAL_BUTTON_TEXT: "Start a return",
  PORTAL_GIFT_BUTTON_TEXT: "Returning a gift?",
  PORTAL_POLICY_LINK_TEXT: "Return Policy",
  PORTAL_WARRANTY_LINK_TEXT: "Register a product or file a warranty claim",
  ITEMS_BEING_RETURNED_SECTION_HEADER: "Return items",
  NEW_ITEMS_SECTION_HEADER: "New items",
  ITEMS_DISCLAIMER:
    "The amounts listed below are estimates and may change upon processing if packages have been used or open.",
  THIRD_PARTY_ITEMS_HEADER: "Select items",
  THIRD_PARTY_ITEMS_SUBHEADER:
    "Choose the items that you wish to report a claim on.",
  THIRD_PARTY_DOCUMENT_TITLE: "Third-party Claim",
  THIRD_PARTY_HEADER: "",
  IN_STORE_RETURN_SUBTEXT: "Drop off at a nearby store",
  IN_STORE_RETURN_TEXT: "Return to store",
  INSTANT_EXCHANGE_DISCLAIMER_SUBTEXT: "",
  FEES_HEADER: "Return value",
  FEES_ORDER_HEADER: "New order",
  RETURN_ITEMS_HEADER: "Return items",
  FREE_SHIPPING_LABEL_TEXT: "Free shipping label covered by",
  FREE_SHIPPING_LABEL_TEXT_NO_BRANDING: "Free shipping label",
  REVIEW_SUBMIT_BUTTON_TEXT: "Submit return",
  REVIEW_SHIPPING_FROM_TEXT: "Returning items from",
  REVIEW_SHIPPING_TO_SAME_TEXT: "Same as returning items from",
  REVIEW_LABEL_COVERAGE: "Return covered for free by",
  REVIEW_FLOW_HEADER: "Review your return",
  STATUS_STEPS_TITLE: "What happens next?",
  STATUS_MANUAL_REVIEW_TITLE: "We'll review your return request",
  STATUS_MANUAL_REVIEW_SUBTITLE:
    "We'll email you the return label if your return is approved",
  STATUS_IN_TRANSIT_TITLE: "Pack up your returns",
  STATUS_IN_TRANSIT_SUBTITLE: "Print your shipping label",
  STATUS_IN_TRANSIT_QR_CODE: "(or open the QR code)",
  STATUS_IN_TRANSIT_QR_CODE_ONLY: "Show the QR code at the carrier's location",
  STATUS_IN_TRANSIT_MULTI_SHIPMENT_SUBTITLE:
    "Look below for all of your shipping labels",
  STATUS_PROCESSED_TITLE: "Carrier delivers the return package to us",
  STATUS_PROCESSED_SUBTITLE: "We'll review and process your return",
  STATUS_PROCESSED_REPAIR_TITLE: "We process the repair",
  STATUS_PROCESSED_REPAIR_SUBTITLE:
    "If the item(s) is not repairable, we will replace or refund the item",
  STATUS_SHIPPING_TEXT:
    "Please confirm the address you'd like your new order shipped to.",
  STATUS_DROP_OFF_SUBTITLE: "",
  EMAIL_SUBJECT: "We received your return request",
  EMAIL_HEADING: "Thanks for your return request.",
  EMAIL_BODY:
    "Please follow the steps below so that we can process your return as quickly as possible.",
  EMAIL_SHIPMENT_LABEL: "Items to ship back:",
  EMAIL_SHIPMENT_TITLE: "Shipment",
  EMAIL_SHIPMENT_URL: "shipping label(s)",
  EMAIL_STEP_1: "Package all items you're requesting to be returned.",
  EMAIL_REVIEW_SUBJECT: "A new return requires a review",
  EMAIL_REVIEW_BODY_1: "A customer created a return",
  EMAIL_CREATED_SUBJECT: "A return has been created",
  EMAIL_CREATED_HEADING: "A new return has been created",
  EMAIL_CREATED_BODY_1: "A customer created a return",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Your withdrawal has been submitted",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Hi {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "We've received your withdrawal for order {{order_number}}. Your withdrawal will be processed soon.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "You can view the status of your withdrawal at any time using the link below.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "View withdrawal",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Thank you,",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBMITTED_ON: "Submitted on:",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_ITEMS: "Items",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_TAXES: "Taxes:",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_DUTIES: "Duties:",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SHIPPING_REFUND: "Shipping:",
  WITHDRAWAL_CANCELED_EMAIL_SUBJECT: "Your order was successfully canceled",
  WITHDRAWAL_CANCELED_EMAIL_GREETING: "Hi {{customer_name}},",
  WITHDRAWAL_CANCELED_EMAIL_BODY:
    "Your order {{order_number}} has been successfully canceled.",
  WITHDRAWAL_CANCELED_EMAIL_DETAILS:
    "You can view your withdrawal details here.",
  WITHDRAWAL_CANCELED_EMAIL_CTA: "View withdrawal",
  WITHDRAWAL_CANCELED_EMAIL_THANK_YOU: "Thanks,",
  GIFT_RECEIPT_EMAIL_SUBJECT: "🎁 Here's Your Gift Receipt!",
  GIFT_RECEIPT_EMAIL_HEADER: "I hope you're enjoying your gift!",
  GIFT_RECEIPT_EMAIL_BODY:
    "Just in case you'd like to exchange it for another size, color, or item, here's a digital gift receipt. I won't be notified if you choose to return or exchange it. You can click the link or scan the QR code below to get started:",
  GIFT_RECEIPT_EMAIL_LINK_TEXT: "Click here to start a return or exchange",
  IN_STORE_RETURN_EMAIL_STEP_1:
    "Gather all items you're requesting to be returned.",
  IN_STORE_RETURN_EMAIL_STEP_2:
    "Show this QR code below to the store associate to process your return or exchange.",
  SHOPIFY_NOTE: "This is an exchange order generated from Redo, for order",
  REVIEW_HEADER_TEXT: "Review your return",
  CHOOSE_ITEMS_TEXT: "Choose items you're returning",
  CHOOSE_VARIANT_TEXT: "Select the type that you're returning",
  PENDING_ITEM_PILL_TEXT: "Ready for return",
  CONFIRMATION_HEADER_TEXT_SUBMIT: "Your return has been submitted",
  CONFIRMATION_HEADER_SUBTEXT:
    "We have received your submission. Your return will be processed soon.",
  CONFIRMATION_HEADER_TEXT_SUBMIT_WITH_ERRORS:
    "There were problems submitting your return",
  CONFIRMATION_HEADER_TEXT_REJECT: "Your return has been rejected",
  DRAFT_ORDER_HEADER: "Your return submission is almost complete",
  DRAFT_ORDER_SUBTITLE:
    "Pay for your exchange to receive your return label and complete your submission.",
  DROP_OFF_PACKAGE_TEXT: "Drop off package",
  DROP_OFF_PACKAGE_SUBTEXT: "Take your package to a nearby",
  GREEN_RETURN_PROCESS_STEP_TEXT: "We process the return",
  PORTAL_ORDERS_TABLE_RETURNS_HEADER: "Returns / Claims",
  PORTAL_ORDER_TABLE_RETURN_LINK_TEXT: "View return",
  ORDER_DETAILS_LIST_TITLE_TEXT: "Returns",
  ORDER_DETAILS_LIST_ITEM_TEXT: "Return",
  ADDRESS_PICKUP_UNAVAILABLE: "Pickup is not available at this address",
  HOW_YOU_WANT: "How do you want to return your items?",
  PICK_BEST_METHOD: "Pick the method that works best for your return.",
  RETURN_OPTION_MODAL_TITLE: "How would you like to return this item?",
  RETURN_OPTION_MODAL_SUBTEXT: "Select how you would like to proceed.",
  SELECT_ITEMS_RETURN_HEADER: "Select items to return",
  SELECT_ITEMS_RETURN_SUBHEADER: "Choose the items that you wish to return.",
  GREEN_RETURN_METHOD_TITLE: "Keep your item",
  GREEN_RETURN_METHOD_TITLE_PLURAL: "Keep your items",
  GREEN_RETURN_METHOD_SUBTITLE:
    "You are not required to return this item. Keep it, throw it away, or gift it to a friend.",
  GREEN_RETURN_METHOD_SUBTITLE_PLURAL:
    "You are not required to return these items. Keep them, throw them away, or gift them to a friend.",
  STANDARD_EXCHANGE_SUB_HEADER:
    "You ship your return item back before your new package gets sent to you.",
  INSTANT_EXCHANGE_SUB_TEXT:
    "Get your new items immediately! Submit your return and get your exchange items shipped to you right away.",
  RETURN_DETAILS_HEADER: "Return details",
  RETURN_DETAILS_SUB_HEADER: "Add the return details for each item.",
  ITEM_DETAILS_RETURN_HEADER: "Add return reasons",
  ITEM_DETAILS_RETURN_EDIT_HEADER: "Edit return reasons",
  ITEM_DETAILS_RETURN_SUB_HEADER: "Tell us why you are returning these items",
  ITEM_DETAILS_ADD_BUTTON_TEXT: "Add details",
  ITEM_DETAILS_EDIT_BUTTON_TEXT: "Edit",
  SAME_ITEM_EXCHANGE_TITLE: "Exchange for same item",
  SAME_ITEM_EXCHANGE_SUBTITLE: "Get the same item back",
  VARIANT_EXCHANGE_TITLE: "Select different style",
  VARIANT_EXCHANGE_SUBTITLE: "Get the same item, but in a different style",
  EXCHANGE_GROUPS_TITLE: "Choose different products",
  EXCHANGE_GROUPS_SUBTITLE: "Select from available exchange collections",
  BACKORDER_HEADING: "Item on backorder",
  BACKORDER_SUBTITLE: "This item will be available soon",

  ShipmentMethodName_PICKUP_TITLE: "Pickup",
  ShipmentMethodName_IN_STORE_TITLE: "Return in store",
  ShipmentMethodName_DROPOFF_TITLE: "Easy drop-off for fastest refund",
  ShipmentMethodName_SELF_SHIP_TITLE: "Box and ship it back to us",
  ShipmentMethodName_HAPPY_RETURNS_TITLE: "Happy returns",
  ShipmentMethodName_BLUE_YONDER_TITLE: "Box-free return location",
  /** @deprecated ReturnBear is retired; the portal never renders this method. */
  ShipmentMethodName_RETURN_BEAR_TITLE: "Box-free return location",
  ShipmentMethodName_SETTLEMENT_TITLE: "Settlement",
  ShipmentMethodName_MANUAL_LABEL_TITLE: "Custom label",

  ShipmentMethodName_PICKUP_SUBTEXT: "Pickup from my doorstep",
  ShipmentMethodName_IN_STORE_SUBTEXT: "Drop it off at a nearby store",
  ShipmentMethodName_DROPOFF_SUBTEXT:
    "Drop off your item at a nearby location. No packaging or printing required.",
  ShipmentMethodName_SELF_SHIP_SUBTEXT:
    "Print a shipping label and bring it to a carrier",
  ShipmentMethodName_HAPPY_RETURNS_SUBTEXT: "",
  ShipmentMethodName_BLUE_YONDER_SUBTEXT:
    "Take it to one of our nearby locations. No need for packaging or shipping.",
  /** @deprecated ReturnBear is retired; the portal never renders this method. */
  ShipmentMethodName_RETURN_BEAR_SUBTEXT:
    "Take it to one of our nearby locations. No need for packaging or shipping.",
  ShipmentMethodName_SETTLEMENT_SUBTEXT: "",
  ShipmentMethodName_MANUAL_LABEL_SUBTEXT:
    "We can’t provide a return label for your location, but don’t worry, we’ll give you step-by-step instructions on the next page for sending your items back.",

  ShipmentMethodName_BLUE_YONDER_LOCATIONS_TEXT: "Closest box-free locations:",

  PICKUP_MODAL_MAIN_TEXT: "Leave it on your doorstep. We'll handle the rest.",
  PICKUP_MODAL_SUB_TEXT:
    "Pack up your return and leave it at your door. We'll take care of it for only %price%.",
  PICKUP_MODAL_PICKUP_BUTTON_TEXT: "Schedule package pickup",
  PICKUP_MODAL_SHIPPING_BUTTON_TEXT: "Ship back to us",
  ORDER_DETAILS_RETURN_STATUS_SUBTITLE: "a refund has been issued",
  ORDER_DETAILS_EXCHANGE_STATUS_SUBTITLE: "an exchange has been processed",
  ORDER_DETAILS_STORE_CREDIT_STATUS_SUBTITLE: "store credit has been issued",
  variants: {
    claim: {
      TYPE_DISPLAY_NAME: "claim",
      PORTAL_BUTTON_TEXT: "Start a claim",
      PORTAL_GIFT_BUTTON_TEXT: "Start a claim for a gift",
      PORTAL_POLICY_LINK_TEXT: "Claim Policy",
      ITEMS_BEING_RETURNED_SECTION_HEADER: "What you're filing a claim for:",
      NEW_ITEMS_SECTION_HEADER: "Replacement items:",
      FEES_HEADER: "Claim value",
      FEES_ORDER_HEADER: "Replacement order",
      REVIEW_SUBMIT_BUTTON_TEXT: "Submit claim",
      REVIEW_SHIPPING_FROM_TEXT: "Shipping from",
      REVIEW_SHIPPING_TO_SAME_TEXT: "Same as shipping from",
      REVIEW_LABEL_COVERAGE: "Claim covered for free by",
      REVIEW_FLOW_HEADER: "Review your shipping claim",
      STATUS_MANUAL_REVIEW_TITLE: "We'll review your claim request",
      STATUS_MANUAL_REVIEW_SUBTITLE:
        "We'll email you a label for your items if your claim is approved",
      STATUS_PROCESSED_TITLE: "Carrier delivers the package to us",
      STATUS_PROCESSED_SUBTITLE: "We'll review and process your claim",
      STATUS_SHIPPING_TEXT:
        "Please confirm the address you'd like your replacement items shipped to.",
      EMAIL_SUBJECT: "We received your claim request",
      EMAIL_HEADING: "Thanks for your claim request.",
      EMAIL_BODY:
        "Please follow the steps below so that we can process your claim as quickly as possible.",
      EMAIL_STEP_1: "Package all items you're filing a claim for.",
      EMAIL_REVIEW_SUBJECT: "A new claim requires a review",
      EMAIL_REVIEW_BODY_1: "A customer created a package protection claim",
      EMAIL_CREATED_SUBJECT: "A claim has been created",
      EMAIL_CREATED_HEADING: "A new claim has been created",
      EMAIL_CREATED_BODY_1: "A customer created a claim",
      IN_STORE_RETURN_EMAIL_STEP_1:
        "Gather all items you're filing a claim for.",
      SHOPIFY_NOTE:
        "This is a replacement order generated from Redo, for order",
      REVIEW_HEADER_TEXT: "Submitting claim",
      CHOOSE_ITEMS_TEXT: "Choose items",
      CONFIRMATION_HEADER_TEXT_SUBMIT: "Your claim has been submitted",
      CONFIRMATION_HEADER_SUBTEXT:
        "We have received your submission. Your claim will be processed soon.",
      CONFIRMATION_HEADER_TEXT_SUBMIT_WITH_ERRORS:
        "There were problems submitting your claim",
      CONFIRMATION_HEADER_TEXT_REJECT: "Your claim has been rejected",
      DRAFT_ORDER_HEADER: "Your claim submission is almost complete",
      DRAFT_ORDER_SUBTITLE:
        "Pay for your exchange to receive your return label and complete your claim submission.",
      DROP_OFF_PACKAGE_TEXT: "Drop off package",
      DROP_OFF_PACKAGE_SUBTEXT: "Take your package to a nearby",
      PENDING_ITEM_PILL_TEXT: "Ready for claim",
      PORTAL_ORDER_TABLE_RETURN_LINK_TEXT: "View claim",
      ORDER_DETAILS_LIST_ITEM_TEXT: "Claim",
      ORDER_DETAILS_LIST_TITLE_TEXT: "Claims",
      GREEN_RETURN_PROCESS_STEP_TEXT: "We process the claim",
      RETURN_ITEMS_HEADER: "Claim items",
    },
    exchange: {
      PORTAL_BUTTON_TEXT: "Start exchange or return",
      EMAIL_SUBJECT: "We received your return or exchange request",
      EMAIL_BODY:
        "Package all items you're requesting to be returned or exchanged.",
      EMAIL_STEP_1:
        "Package all items you're requesting to be returned or exchanged.",
      IN_STORE_RETURN_EMAIL_STEP_1:
        "Gather all items you're requesting to be returned or exchanged.",
      SELECT_ITEMS_RETURN_SUBHEADER:
        "Choose the items that you wish to return or exchange.",
    },
    return_claim: {
      PORTAL_BUTTON_TEXT: "Start return or claim",
      PORTAL_GIFT_BUTTON_TEXT: "Start a return or claim for a gift",
      PORTAL_POLICY_LINK_TEXT: "Return/Claim Policy",
    },
    pickup: {
      REVIEW_SHIPPING_FROM_TEXT: "Pickup Address",
      STATUS_IN_TRANSIT_SUBTITLE: "Use original packaging or poly bag",
      STATUS_PROCESSED_TITLE: "Package Pickup",
      STATUS_PROCESSED_SUBTITLE:
        "Carrier will pickup the package from the pickup address and deliver the return to us. We'll review and process your return",
      EMAIL_HEADING: "Thank you for your pickup request on your return order",
    },
    // TODO: Separate warranty and repair language
    warranty: {
      TYPE_DISPLAY_NAME: "warranty",
      PORTAL_BUTTON_TEXT: "File a warranty claim",
      ITEMS_BEING_RETURNED_SECTION_HEADER: "Items you're submitting:",
      REVIEW_SUBMIT_BUTTON_TEXT: "Submit warranty claim request",
      REVIEW_SHIPPING_FROM_TEXT: "Sending items from",
      REVIEW_FLOW_HEADER: "Review your warranty claim request",
      REVIEW_HEADER_TEXT: "Review your warranty claim request",
      PENDING_ITEM_PILL_TEXT: "Ready for claim",
      STATUS_MANUAL_REVIEW_TITLE: "We'll review your warranty claim request",
      STATUS_MANUAL_REVIEW_SUBTITLE:
        "We'll email you the label if your warranty claim is approved",
      STATUS_IN_TRANSIT_TITLE: "Pack up your items",
      STATUS_PROCESSED_TITLE: "Carrier delivers the package to us",
      STATUS_PROCESSED_SUBTITLE:
        "We'll review and process your warranty claim request",
      EMAIL_SUBJECT: "We received your warranty claim request",
      EMAIL_HEADING: "Thanks for your warranty claim request.",
      EMAIL_BODY:
        "Please follow the steps below so that we can process your warranty claim as quickly as possible.",
      EMAIL_STEP_1: "Package all items you're requesting to be processed.",
      EMAIL_REVIEW_SUBJECT: "A new warranty claim requires a review",
      EMAIL_REVIEW_BODY_1: "A customer created a warranty claim",
      EMAIL_CREATED_SUBJECT: "A warranty claim has been created",
      EMAIL_CREATED_HEADING: "A new warranty claim has been created",
      EMAIL_CREATED_BODY_1: "A customer created a warranty claim",
      IN_STORE_RETURN_EMAIL_STEP_1:
        "Gather all items you're requesting to be processed.",
      CHOOSE_ITEMS_TEXT: "Choose items",
      CHOOSE_VARIANT_TEXT: "Select the type that you're submitting",
      // LOGIN_FIELD_TWO_LABEL: "Order # / Tracking # / Warranty Registration #",
      LOGIN_FIELD_TWO_LABEL: "Order # or Tracking #",
      CONFIRMATION_HEADER_TEXT_SUBMIT: "Your warranty claim has been submitted",
      CONFIRMATION_HEADER_SUBTEXT:
        "We have received your submission. Your warranty claim will be processed soon.",
      CONFIRMATION_HEADER_TEXT_SUBMIT_WITH_ERRORS:
        "There were problems submitting your warranty claim",
      CONFIRMATION_HEADER_TEXT_REJECT: "Your warranty claim has been rejected",
      FEES_HEADER: "Warranty claim value",
      RETURN_ITEMS_HEADER: "Warranty claim items",
    },
    recycle: {
      TYPE_DISPLAY_NAME: "Recycle",
      PORTAL_BUTTON_TEXT: "Start a recycling request",
      ITEMS_BEING_RETURNED_SECTION_HEADER: "Items you're submitting:",
      REVIEW_SUBMIT_BUTTON_TEXT: "Submit recycling request",
      REVIEW_SHIPPING_FROM_TEXT: "Sending items from",
      REVIEW_FLOW_HEADER: "Review your recycling request",
      REVIEW_HEADER_TEXT: "Review your recycling request",
      PENDING_ITEM_PILL_TEXT: "Ready to recycle",
      STATUS_MANUAL_REVIEW_TITLE: "We'll review your recycling request",
      STATUS_MANUAL_REVIEW_SUBTITLE:
        "We'll email you the label if your recycling request is approved",
      STATUS_IN_TRANSIT_TITLE: "Pack up your items",
      STATUS_PROCESSED_TITLE: "Carrier delivers the package to us",
      STATUS_PROCESSED_SUBTITLE:
        "We'll review and process your recycling request",
      EMAIL_SUBJECT: "We received your recycling request",
      EMAIL_HEADING: "Thanks for your recycling request.",
      EMAIL_BODY:
        "Please follow the steps below so that we can process your recycling request as quickly as possible.",
      EMAIL_STEP_1: "Package all items you're requesting to be processed.",
      EMAIL_REVIEW_SUBJECT: "A new warranty claim requires a review",
      EMAIL_REVIEW_BODY_1: "A customer created a recycling request",
      EMAIL_CREATED_SUBJECT: "A recycling request has been created",
      EMAIL_CREATED_HEADING: "A new warranty claim has been created",
      EMAIL_CREATED_BODY_1: "A customer created a recycling request",
      IN_STORE_RETURN_EMAIL_STEP_1:
        "Gather all items you're requesting to be processed.",
      CHOOSE_ITEMS_TEXT: "Choose items",
      CHOOSE_VARIANT_TEXT: "Select the type that you're submitting",
      // LOGIN_FIELD_TWO_LABEL: "Order # / Tracking # / Warranty Registration #",
      LOGIN_FIELD_TWO_LABEL: "Order # or Tracking #",
      CONFIRMATION_HEADER_TEXT_SUBMIT:
        "Your recycling request has been submitted",
      CONFIRMATION_HEADER_SUBTEXT:
        "We have received your submission. Your recycling request will be processed soon.",
      CONFIRMATION_HEADER_TEXT_SUBMIT_WITH_ERRORS:
        "There were problems submitting your recycling request",
      CONFIRMATION_HEADER_TEXT_REJECT:
        "Your recycling request has been rejected",
      FEES_HEADER: "Recycling value",
      RETURN_ITEMS_HEADER: "Recycling items",
      ShipmentMethodName_SELF_SHIP_TITLE:
        "Box up your empties and ship them back to us",
      ShipmentMethodName_SELF_SHIP_SUBTEXT:
        "You'll receive a shipping label in your email shortly.",
      ITEMS_DISCLAIMER:
        "Please note that in order to qualify for your gift card, all the empties you selected must be returned. ",
      THIRD_PARTY_ITEMS_SUBHEADER:
        "Choose the items that you would like to recycle for a gift card",
      THIRD_PARTY_ITEMS_HEADER: "Select items to recycle",
    },
    withdrawal: {
      REVIEW_HEADER_TEXT: "Confirm withdrawal",
      REVIEW_SUBMIT_BUTTON_TEXT: "Submit withdrawal",
      CONFIRMATION_HEADER_TEXT_SUBMIT:
        "Your withdrawal request has been submitted",
      CONFIRMATION_HEADER_SUBTEXT:
        "We have received your submission. Your withdrawal will be processed soon.",
      CONFIRMATION_HEADER_TEXT_SUBMIT_WITH_ERRORS:
        "There were problems submitting your withdrawal request",
      CONFIRMATION_HEADER_TEXT_REJECT:
        "Your withdrawal request has been rejected",
      STATUS_MANUAL_REVIEW_TITLE: "We'll review your withdrawal request",
      STATUS_MANUAL_REVIEW_SUBTITLE:
        "We'll email you the label if your withdrawal is approved",
      STATUS_IN_TRANSIT_TITLE: "Pack up your items",
      STATUS_PROCESSED_TITLE: "Carrier delivers the package to us",
      STATUS_PROCESSED_SUBTITLE: "We'll review and process your withdrawal",
      GREEN_RETURN_PROCESS_STEP_TEXT: "We process the withdrawal",
      PENDING_ITEM_PILL_TEXT: "Ready for withdrawal",
    },
    repair: {
      EMAIL_REVIEW_SUBJECT: "A new repair request requires a review",
      EMAIL_REVIEW_BODY_1: "A customer created a repair request",
      EMAIL_CREATED_SUBJECT: "A repair request has been created",
      EMAIL_CREATED_HEADING: "A new repair request has been created",
      EMAIL_CREATED_BODY_1: "A customer created a repair request",
    },
    "third-party": {
      SHOPIFY_NOTE:
        "This is an exchange order generated from Redo, for warranty registration",
    },
  },
};

// An example of a region override
// export const EN_US: VariantResource<Variants> = {
//   ...COMMON,
//   STATUS_PROCESSED_TITLE: "TEST ONE",
//   variants: {
//     ...COMMON.variants,
//     claim: {
//       ...COMMON.variants?.claim,
//       STATUS_PROCESSED_TITLE: "TEST TWO",
//     },
//   }
// };

export const EN_US: VariantResource<Variants> = { ...COMMON };

export const EN_AU: VariantResource<Variants> = { ...COMMON };

/* cspell:disable */
export const BG_BG: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Вашата заявка за отказ е изпратена",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Здравейте, {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Получихме вашата заявка за отказ за поръчка {{order_number}}. Вашата заявка за отказ ще бъде обработена скоро.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Можете да видите състоянието на заявката си по всяко време чрез връзката по-долу.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Вижте заявката за отказ",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Благодарим ви,",
};

export const HR_HR: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Vaš zahtjev za odustajanje je podnesen",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Pozdrav {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Zaprimili smo vaš zahtjev za odustajanje za narudžbu {{order_number}}. Vaš zahtjev za odustajanje uskoro će biti obrađen.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Status svog zahtjeva možete u bilo kojem trenutku pogledati putem poveznice u nastavku.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Prikaži zahtjev za odustajanje",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Hvala,",
};

export const CS_CZ: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Vaše žádost o odstoupení byla odeslána",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Dobrý den, {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Obdrželi jsme vaši žádost o odstoupení pro objednávku {{order_number}}. Vaše žádost bude brzy zpracována.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Stav své žádosti si můžete kdykoli zobrazit pomocí odkazu níže.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Zobrazit žádost o odstoupení",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Děkujeme,",
};

export const DA_DK: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Din fortrydelsesanmodning er indsendt",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Hej {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Vi har modtaget din fortrydelsesanmodning for ordre {{order_number}}. Din fortrydelsesanmodning bliver behandlet snart.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Du kan til enhver tid se status for din anmodning via linket nedenfor.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Se fortrydelsesanmodning",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Tak,",
};

export const NL_NL: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Uw herroepingsverzoek is ingediend",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Hallo {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "We hebben uw herroepingsverzoek voor bestelling {{order_number}} ontvangen. Uw herroepingsverzoek wordt binnenkort verwerkt.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "U kunt de status van uw verzoek op elk moment bekijken via de onderstaande link.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Herroepingsverzoek bekijken",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Bedankt,",
};

export const EN_IE: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Your withdrawal request has been submitted",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Hi {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "We've received your withdrawal request for order {{order_number}}. Your withdrawal will be processed soon.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "You can view the status of your request at any time using the link below.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "View withdrawal request",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Thank you,",
};

export const ET_EE: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Teie taganemistaotlus on esitatud",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Tere, {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Oleme saanud teie taganemistaotluse tellimusele {{order_number}}. Teie taganemistaotlust töödeldakse peagi.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Saate oma taotluse olekut igal ajal vaadata alloleva lingi kaudu.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Vaata taganemistaotlust",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Täname,",
};

export const FI_FI: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Peruuttamispyyntösi on lähetetty",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Hei {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Olemme vastaanottaneet peruutuspyyntösi tilaukselle {{order_number}}. Peruutuspyyntösi käsitellään pian.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Voit tarkistaa pyyntösi tilan milloin tahansa alla olevasta linkistä.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Näytä peruutuspyyntö",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Kiitos,",
};

export const FR_FR: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Votre demande de rétractation a été envoyée",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Bonjour {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Nous avons reçu votre demande de rétractation pour la commande {{order_number}}. Votre demande de rétractation sera traitée prochainement.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Vous pouvez consulter le statut de votre demande à tout moment en utilisant le lien ci-dessous.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Voir la demande de rétractation",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Merci,",
};

export const DE_DE: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Ihr Widerrufsantrag wurde eingereicht",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Hallo {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Wir haben Ihren Widerrufsantrag für die Bestellung {{order_number}} erhalten. Ihr Widerruf wird in Kürze bearbeitet.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Sie können den Status Ihres Antrags jederzeit über den folgenden Link einsehen.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Widerrufsantrag ansehen",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Vielen Dank,",
};

export const EL_GR: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Το αίτημα υπαναχώρησής σας υποβλήθηκε",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Γεια σας {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Λάβαμε το αίτημα υπαναχώρησής σας για την παραγγελία {{order_number}}. Το αίτημα υπαναχώρησής σας θα υποβληθεί σε επεξεργασία σύντομα.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Μπορείτε να δείτε την κατάσταση του αιτήματός σας ανά πάσα στιγμή χρησιμοποιώντας τον παρακάτω σύνδεσμο.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Προβολή αιτήματος υπαναχώρησης",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Ευχαριστούμε,",
};

export const HU_HU: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT: "Elállási kérelmét elküldtük",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Kedves {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Megkaptuk elállási kérelmét a(z) {{order_number}} rendeléshez. Elállási kérelmét hamarosan feldolgozzuk.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Kérelme állapotát bármikor megtekintheti az alábbi hivatkozáson.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Elállási kérelem megtekintése",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Köszönjük,",
};

export const GA_IE: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Tá d’iarratas tarraingthe siar curtha isteach",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Dia duit {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Tá d’iarratas tarraingthe siar faighte againn don ordú {{order_number}}. Próiseálfar d’iarratas tarraingthe siar go luath.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Is féidir leat stádas d’iarratais a fheiceáil am ar bith leis an nasc thíos.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA:
    "Féach ar an iarratas tarraingthe siar",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Go raibh maith agat,",
};

export const IT_IT: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "La tua richiesta di recesso è stata inviata",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Ciao {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Abbiamo ricevuto la tua richiesta di recesso per l'ordine {{order_number}}. La tua richiesta di recesso sarà elaborata a breve.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Puoi visualizzare lo stato della tua richiesta in qualsiasi momento utilizzando il link qui sotto.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Visualizza richiesta di recesso",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Grazie,",
};

export const LV_LV: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Jūsu atteikuma pieprasījums ir iesniegts",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Sveiki, {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Esam saņēmuši jūsu atteikuma pieprasījumu pasūtījumam {{order_number}}. Jūsu atteikuma pieprasījums drīz tiks apstrādāts.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Jūs jebkurā laikā varat skatīt sava pieprasījuma statusu, izmantojot tālāk norādīto saiti.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Skatīt atteikuma pieprasījumu",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Paldies,",
};

export const LT_LT: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Jūsų atsisakymo prašymas pateiktas",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Sveiki, {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Gavome jūsų atsisakymo prašymą dėl užsakymo {{order_number}}. Jūsų atsisakymo prašymas netrukus bus apdorotas.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Savo prašymo būseną bet kada galite peržiūrėti naudodami toliau pateiktą nuorodą.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Peržiūrėti atsisakymo prašymą",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Ačiū,",
};

export const MT_MT: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "It-talba tiegħek għall-irtirar ġiet sottomessa",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Bongu {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Irċevejna t-talba tiegħek għall-irtirar għall-ordni {{order_number}}. It-talba tiegħek għall-irtirar se tiġi pproċessata dalwaqt.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Tista' tara l-istatus tat-talba tiegħek fi kwalunkwe ħin billi tuża l-link hawn taħt.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Ara t-talba għall-irtirar",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Grazzi,",
};

export const PL_PL: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Twoje żądanie odstąpienia zostało przesłane",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Cześć {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Otrzymaliśmy Twoje żądanie odstąpienia dotyczące zamówienia {{order_number}}. Twoje żądanie odstąpienia zostanie wkrótce przetworzone.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Status swojego żądania możesz sprawdzić w dowolnym momencie, korzystając z poniższego linku.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Wyświetl żądanie odstąpienia",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Dziękujemy,",
};

export const PT_PT: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "O seu pedido de livre resolução foi submetido",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Olá {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Recebemos o seu pedido de livre resolução para a encomenda {{order_number}}. O seu pedido será processado em breve.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Pode consultar o estado do seu pedido a qualquer momento através da ligação abaixo.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Ver pedido de livre resolução",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Obrigado,",
};

export const RO_RO: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Cererea dvs. de retragere a fost trimisă",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Bună, {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Am primit cererea dvs. de retragere pentru comanda {{order_number}}. Cererea dvs. de retragere va fi procesată în curând.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Puteți vedea oricând starea cererii folosind linkul de mai jos.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Vedeți cererea de retragere",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Vă mulțumim,",
};

export const SK_SK: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Vaša žiadosť o odstúpenie bola odoslaná",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Dobrý deň, {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Dostali sme vašu žiadosť o odstúpenie pre objednávku {{order_number}}. Vaša žiadosť bude čoskoro spracovaná.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Stav svojej žiadosti si môžete kedykoľvek pozrieť pomocou odkazu nižšie.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Zobraziť žiadosť o odstúpenie",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Ďakujeme,",
};

export const SL_SI: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Vaša zahteva za odstop je bila oddana",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING:
    "Pozdravljeni, {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Prejeli smo vašo zahtevo za odstop za naročilo {{order_number}}. Vaša zahteva za odstop bo kmalu obdelana.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Stanje svoje zahteve si lahko kadar koli ogledate s spodnjo povezavo.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Ogled zahteve za odstop",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Hvala,",
};

export const ES_ES: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Se ha enviado su solicitud de desistimiento",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Hola {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Hemos recibido su solicitud de desistimiento para el pedido {{order_number}}. Su solicitud de desistimiento se procesará pronto.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Puede consultar el estado de su solicitud en cualquier momento mediante el enlace que aparece a continuación.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Ver solicitud de desistimiento",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Gracias,",
};

export const SV_SE: VariantResource<Variants> = {
  ...COMMON,
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_SUBJECT:
    "Din begäran om ångerrätt har skickats",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_GREETING: "Hej {{customer_name}},",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_1:
    "Vi har tagit emot din begäran om ångerrätt för order {{order_number}}. Din begäran kommer att behandlas snart.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_BODY_2:
    "Du kan när som helst se statusen för din begäran via länken nedan.",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_CTA: "Visa begäran om ångerrätt",
  WITHDRAWAL_REQUEST_SUBMITTED_EMAIL_THANK_YOU: "Tack,",
};
/* cspell:enable */
